import React from 'react';
import { FeatureAppLicenses } from 'components/feature-app-licenses';

export const FeatureAppLicensesPage: React.FC = () => <FeatureAppLicenses />;
